import { SlideFrame } from '../SlideFrame';

export function SlideThisPresentation({ pageNum }: { pageNum: number }) {
  return (
    <SlideFrame pageNum={pageNum} title="THIS PRESENTATION">
      <div className="flex h-full items-center justify-center px-12 pt-4 pb-8">
        <div className="max-w-[900px] rounded-2xl border border-[#c9a84c]/40 bg-[#1e293b] px-14 py-12 shadow-lg shadow-[#c9a84c]/10">
          <div className="text-[14px] uppercase tracking-[0.28em] text-[#c9a84c] mb-6">This Presentation</div>
          <div className="text-[#e2e8f0] text-[22px] leading-relaxed">
            The walk-through you are watching was built with AI. Every screen you have seen, and every screen that follows, was assembled with the same tooling we use to run the firm.
          </div>
        </div>
      </div>
    </SlideFrame>
  );
}
